import type {
  InternalDataLakeLogsResult,
  InternalDataLakeLogsResultJSON,
} from 'data-lake/preview/types/internal/Types';

export default {
  convert({
    effective_timerange: effectiveTimerange,
    id,
    messages,
    total_results: total,
    type,
  }: InternalDataLakeLogsResultJSON): InternalDataLakeLogsResult {
    return {
      effectiveTimerange,
      id,
      messages: messages,
      total,
      type: type,
    };
  },
};
